import { PayloadAction, createSlice } from "@reduxjs/toolkit"
import { logout } from "../actions/auth"
import {
	AllCorporatesListState,
	CorporateEssential,
	CorporatesState,
	getUserAllCorporates,
} from "../actions/corporates"

const initialState: AllCorporatesListState = {
	loading: false,
	error: undefined,
	list: [],
	selected: undefined,
}

const corporateAllSlice = createSlice({
	name: "corporatesUser",
	initialState: initialState,
	reducers: {
		openDrawer: (
			state: ICorporateEditState,
			action: PayloadAction<IPayloadOpenDrawer>
		) => {
			state.isDrawerOpen = true
			state.isEditMode = action.payload.isEditMode || false
			state.currentBank = action.payload.bank || undefined
		},
		closeDrawer: (state) => {
			state.isDrawerOpen = false
			state.isEditMode = false
			state.currentBank = undefined
		},
		clearError: (state: AllCorporatesListState) => {
			state.error = undefined
			state.loading = false
		},
		resetDefault: (state: AllCorporatesListState) => {
			state.loading = false
			state.error = undefined
			state.list = []
			state.selected = undefined
		},
		selectCorporate: (
			state: AllCorporatesListState,
			action: PayloadAction<CorporateEssential | undefined>
		) => {
			state.selected = action?.payload
		},
	},
	extraReducers: (builder) => {
		builder
			.addCase(logout.fulfilled, () => initialState)
			.addCase(
				getUserAllCorporates.pending,
				(state: AllCorporatesListState) => {
					state.loading = true
					state.error = undefined
				}
			)
			.addCase(
				getUserAllCorporates.fulfilled,
				(
					state: AllCorporatesListState,
					action: PayloadAction<CorporatesState[]>
				) => {
					state.loading = false
					state.error = undefined
					state.list = action?.payload
				}
			)
			.addCase(
				getUserAllCorporates.rejected,
				(state: AllCorporatesListState, action) => {
					state.loading = false
					state.error = action?.payload.message
				}
			)
	},
})

export const { clearError, resetDefault, selectCorporate } =
	corporateAllSlice.actions

export default corporateAllSlice.reducer
